<template>
  <div class="rooms-container" :class='{ "rooms-container-edit": getStyleEdition }'>
    <div class="btn-multiroom-back" v-if="getSelectedRoom !== ''">
      <div class="room-name">{{ getSelectedRoomName }}</div>
      <el-button @click="unSelectRoom()" icon="el-icon-menu"></el-button>
    </div>
    <multi-rooms v-if="getSelectedRoom === ''" />
    <single-room v-if="getSelectedRoom !== ''" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import MultiRooms from '../room/MultiRooms';
import SingleRoom from '../room/SingleRoom';

export default {
  name: 'MainRightSide',
  components: { MultiRooms, SingleRoom },
  computed: {
    ...mapGetters({
      getSelectedRoom: 'newRooms/getSelectedRoom',
      getStyleEdition: 'newRooms/getStyleEdition',
      getAllRoomsIsLoaded: 'newRooms/getAllRoomsIsLoaded',
      getSelectedRoomName: 'newRooms/getSelectedRoomName',
      getModEdition: 'newRooms/getModEdition'
    })
  },
  methods: {
    ...mapMutations({
      setSelectedRoom: 'newRooms/setSelectedRoom',
      setPopupTableSelected: 'displayer/setPopupTableSelected'
    }),
    ...mapActions({
      unSelectedTables: 'newRooms/unSelectedTables',
      saveRoom: 'newRooms/saveRoom'
    }),
    unSelectRoom: function () {
      this.unSelectedTables()
      if (this.getModEdition) {
        this.saveRoom().then(res => {
          this.setSelectedRoom('')
          this.setPopupTableSelected(false)
        })
      } else {
        this.setSelectedRoom('')
        this.setPopupTableSelected(false)
      }
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/components/layout/rooms";
</style>
